module.exports = __webpack_public_path__ + "static/logo-8bf1b8ea91c96fd6ebea3b2d53a6892f.svg";